module.exports = __webpack_public_path__ + "img/1356.5af93b94.jpg";